import * as React from 'react';
import cn from 'classnames';
import { observer } from 'mobx-react';

import { usePageTemplateMenuStore } from 'stores/PageTemplateMenuStore';

import Right from '../Right';

import Breadcrumbs from './Breadcrumbs';

import './TopMenu.modules.scss';

const TopMenu: React.FC = () => {
  const menuStore = usePageTemplateMenuStore();

  return (
    <div
      styleName={cn('top-menu', menuStore.isMobileMenu && 'top-menu_mobile')}
    >
      <Breadcrumbs />
      {!menuStore.isMobileMenu && <Right styleName="top-menu__right" />}
    </div>
  );
};

export default observer(TopMenu);
